module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Mitarbeiterliste Detail-abed088a64e07a23879cd0b85eee5bae.png";